module.exports = __webpack_public_path__ + "static/img/icon_ssr.402dffbb.png";